// tslint:disable:max-line-length
import {Compiler, ComponentFactoryResolver, Injectable, Injector, ReflectiveInjector, SystemJsNgModuleLoader} from "@angular/core";
import {Http} from "@angular/http";
import {TciContribMessaging, TciContribModelService, TciServiceContribution} from "./tci-contrib.model";
import {CookieService} from "angular2-cookie/core";
import {TciContribRequestService} from "./tci-contrib-request.service";
import {IMessaging, ITCIServiceContribution, jsonToStrMap, MESSAGING_SUBJECTS, SERVICE_URLS, TCI_MODULE_CONTRIBUTION} from "@tci/common";
import {Observable} from "rxjs";
import {TciContribModuleMap} from "./tci-contrib-module.map";
import * as lodash from "lodash";
import * as CryptoJS from "crypto-js";
import * as SystemJSLoader from "systemjs";
import {NgWindowRefService} from "../ng-shared/ng-services/ng-window-ref.service";

declare var SystemJS: SystemJSLoader.System;
// tslint:disable:max-line-length
@Injectable()
export class TciContribService {

    private static instance: TciContribService;
    contribs: any = [];
    contribMessaging: TciContribMessaging = new TciContribMessaging();
    hashTable: any = {};
    initCompleted = false;
    private config: TciContribModuleMap;

    public static getInstance(_injector: Injector,
                              http: Http,
                              resolver: ComponentFactoryResolver,
                              loader: SystemJsNgModuleLoader,
                              compiler: Compiler,
                              // paletteService: PaletteService,
                              modelService: TciContribModelService,
                              cookieService: CookieService,
                              contribReqService: TciContribRequestService,
                              _window: NgWindowRefService): TciContribService {
        if (!TciContribService.instance) {
            return new TciContribService(_injector,
                http,
                resolver,
                loader,
                compiler,
                // paletteService,
                modelService,
                cookieService,
                contribReqService,
                _window);
        }
    }

    constructor(private _injector: Injector,
                private http: Http,
                private resolver: ComponentFactoryResolver,
                private loader: SystemJsNgModuleLoader,
                private compiler: Compiler,
                // paletteService: PaletteService,
                private  modelService: TciContribModelService,
                private cookieService: CookieService,
                private contribReqService: TciContribRequestService,
                private _window: NgWindowRefService) {

        try {
            if ((this._window.nativeWindow.opener
                && this._window.nativeWindow.opener.tci
                && this._window.nativeWindow.opener.tci.namespace
                && this._window.nativeWindow.opener.tci.namespace.publicFunc)) {
                console.log("Skipping contribution loading");
                // Child window with namespace studio and publicFunc, so don't load contributions
            } else {
                this.init(http)
                    .subscribe(data => {
                        // Done loading the contributions
                        this.contribMessaging.emit(MESSAGING_SUBJECTS.CONTRIB_INIT_SUBJECT, data);
                        modelService.bindContribService(this);
                        this.initCompleted = true;
                    });

            }
        } catch (err) {
            this.init(http)
                .subscribe(data => {
                    // Done loading the contributions
                    this.contribMessaging.emit(MESSAGING_SUBJECTS.CONTRIB_INIT_SUBJECT, data);
                    modelService.bindContribService(this);
                    this.initCompleted = true;
                });
        }

    }

    getMessaging(): IMessaging {
        return this.contribMessaging;
    }

    isInitialized(): boolean {
        return this.initCompleted;
    }

    /**
     * Initialize contribution service
     * @private
     * @param http
     */
    public init(http: Http, refresh?: boolean): Observable<any> {
        this.initCompleted = false;
        this.config = TciContribModuleMap.getInstance();
        const httpProvider = ReflectiveInjector.resolve([Http, {
            provide: TciContribModelService,
            useValue: this.modelService
        }]);
        const contribInjector = ReflectiveInjector.fromResolvedProviders(httpProvider);
        return Observable.create(observer => {
            this.contribReqService.getContributions(refresh)
                .subscribe(contribData => {
                    this.contribs = contribData;
                    const contribs = contribData;
                    this.calculateHash(lodash.cloneDeep(contribs));
                    http.get(SERVICE_URLS.MODULES)
                        .map(res => {
                            const body = res.json();
                            return body || {};
                        })
                        .subscribe(data => {
                                if (this.config.moduleMap.size === 0) {
                                    this.config.moduleMap = jsonToStrMap<TCI_MODULE_CONTRIBUTION<ITCIServiceContribution>>(data);
                                }
                                const cfg = (<any>SystemJS).getConfig();
                                cfg.paths["tci-contrib:"] = System.baseURL + "api/v1/contributions";
                                this.config.moduleMap.forEach((v, k) => {
                                    const moduleFileName = this.getModuleFileName(v.files); // activity.module.js
                                    if (moduleFileName !== null) {
                                        cfg.map[v.name] = "tci-contrib:/" + v.name;
                                        cfg.packages[v.name] = {
                                            main: this.getModuleFileName(v.files),
                                            defaultExtension: "js"
                                        };
                                    }
                                });
                                SystemJS.config(cfg);
                                const modules = [], resultObservables = [];
                                for (const v in data) {
                                    if (v) {
                                        modules.push(data[v]);
                                    }
                                }
                                Observable.from(modules)
                                    .map(v => {
                                        const moduleFileName = this.getModuleFileName(v.files); // activity.module.js
                                        if (moduleFileName !== null && v.service === null) {
                                            resultObservables.push(
                                                Observable.create(obs => {
                                                    Observable.fromPromise(this.loader.load(v.name))
                                                        .subscribe(moduleFactory => {
                                                            Observable.fromPromise(this.compiler.compileModuleAndAllComponentsAsync<any>(moduleFactory.moduleType))
                                                                .subscribe(factory => {
                                                                        const modRef = moduleFactory.create(contribInjector);
                                                                        v.service = <ITCIServiceContribution>modRef.injector.get(TciServiceContribution);
                                                                        this.config.moduleMap.set(v.name, v);
                                                                        // console.log(v.service);
                                                                        obs.next("");
                                                                        obs.complete();
                                                                    },
                                                                    err => {
                                                                        obs.next("");
                                                                        obs.complete();
                                                                    });
                                                        }, err => {
                                                            obs.next("");
                                                            obs.complete();
                                                        });
                                                })
                                            );
                                        }
                                        return v;
                                    })
                                    .subscribe(module => {
                                        // console.log(module);
                                    });

                                Observable.merge(...resultObservables)
                                    .subscribe(v => {
                                        // Subscribe
                                    }, err => {
                                        console.error(err);
                                        // error
                                    }, () => {
                                        observer.next("Done");
                                        observer.complete();
                                    });
                            },
                            err => observer.next(err || "Server error"));
                });
        });

    }

    private calculateHash(contribs: any[]) {
        for (let i = 0; i < contribs.length; i++) {
            const contrib = contribs[i];
            const key = getKey(contrib, false);
            if (contrib.s3Prefix) {
                delete contrib.s3Prefix;
            }
            if (contrib.key) {
                delete contrib.key;
            }
            if (contrib.lastModifiedDate) {
                delete contrib.lastModifiedDate;
            }
            const hash = CryptoJS.SHA256(JSON.stringify(contrib)).toString();
            this.hashTable[key] = {hash: hash, version: contrib.version};

        }
    }

    public contribHash(): Observable<any> {
        return Observable.create(observer => {
            if (Object.keys(this.hashTable).length > 0) {
                observer.next(this.hashTable);
                observer.complete();
            } else {
                // this.contribMessaging.on(MESSAGING_SUBJECTS.CONTRIB_INIT_SUBJECT, data => {
                //     if (data === "Done") {
                //         this.paletteService.getSchemasFromServer()
                //             .subscribe(contribs => {
                //                 this.calculateHash(lodash.cloneDeep(contribs));
                //                 observer.next(this.hashTable);
                //                 observer.complete();
                //             });
                //     }
                // });
            }
        });
    }

    // public getJsonForActivity(key: string): Observable<any> {
    //     return Observable.create(observer => {
    //         this.paletteService.getSchemasFromServer()
    //             .subscribe(contribs => {
    //                 for (let i = 0; i < contribs.length; i++) {
    //                     const contrib = contribs[i];
    //                     let contribKey = "";
    //                     if (contrib.display && contrib.display.category) {
    //                         contribKey += contrib.display.category + "/";
    //                     }
    //                     contribKey += contrib.name;
    //                     if (contribKey === key) {
    //                         observer.next(contrib);
    //                         break;
    //                     }
    //                 }
    //                 observer.complete();
    //             });
    //     });
    //
    // }

    // public getJsonFromServer(): Observable<any> {
    //     return Observable.create(observer => {
    //         this.paletteService.getSchemasFromServer()
    //             .subscribe(contribs => {
    //                     observer.next(contribs);
    //                     observer.complete();
    //                 }
    //             );
    //     });
    // }

    /**
     * @private
     * @param {string[]} files
     * @return {string}
     */
    private getModuleFileName(files: string[]): string {
        for (let i = 0; i < files.length; i++) {
            if (files[i].endsWith(".module.js")) {
                return files[i];
            }
        }
        return null;
    }

    /**
     * Gets list of contributed module names
     * @private
     */
    public getContributionModules(): any {
        const arr: string[] = [];
        this.config.moduleMap.forEach((v, k) => {
            arr.push(k);
        });
        return arr;
    }

    /**
     * Gets the Contribution Service.
     * @param name Contribution name e.g. "wi-log-activity"
     * @private
     */
    public getContributionService(name: string): ITCIServiceContribution {
        return this.config.moduleMap.has(name) ? this.config.moduleMap.get(name).service : null;
    }

    /**
     * Gets the Contribution JSON object based on the unique {{Contribution Category}}/{{Contribution Name}}
     * @param {string} element_type
     * @param {string} contrib_type optional
     */
    getContributionFlowElementByTypeId(element_type: string, contrib_type: string): any {
        let contribution = {};
        for (let i = 0; i < this.contribs.length; i++) {
            let key = "";

            if (this.contribs[i].type === contrib_type) {
                key = getKey(this.contribs[i], false);
            }
            if (key && key === element_type) {
                contribution = this.contribs[i];
                break;
            }
        }
        return contribution;
    }

    public deleteByCategory(category: string) {
        if (category) {
            for (const key in this.hashTable) {
                if (key.startsWith(category + "/")) {
                    delete this.hashTable[key];
                }
            }
        }
    }

    public deleteByContribution(contributionName: string) {
        if (contributionName) {
            for (const key in this.hashTable) {
                if (key === contributionName) {
                    delete this.hashTable[key];
                }
            }
        }
    }

    public getModelService(): TciContribModelService {
        return this.modelService;
    }

}

export function getKey(item: any, s3Prefix?: boolean): string {
    if (item) {
        let category = "Default";
        if (item.display && item.display.category) {
            category = item.display.category;
        }
        category += "/" + item.name;
        if (item.s3Prefix && s3Prefix !== false) {
            category = item.s3Prefix + "/" + category;
        }
        return category;
    }
    return "";
}
